module.exports = __webpack_public_path__ + "media/application/images/ui/icons-masthead-b8ae52986536c68d50c8339e68471ea3.png";